export class Cache<T> {
    private cache = new Map<string, T>();
    private cacheOrder: string[] = [];

    public constructor(private maxSize: number) {}

    public get(key: string): T | undefined {
        return this.cache.get(key);
    }

    public set(key: string, value: T): void {
        this.cache.set(key, value);
        this.cacheOrder.push(key);

        if (this.cache.size > this.maxSize) {
            const oldestKey = this.cacheOrder.shift();
            if (oldestKey !== undefined) {
                this.cache.delete(oldestKey);
            }
        }
    }

    public has(key: string): boolean {
        return this.cache.has(key);
    }
}
